import React, { useEffect, useRef } from 'react';

export default function ScrollProgress() {
  const ref = useRef(null);
  const frame = useRef(null);

  useEffect(() => {
    const update = () => {
      const node = ref.current;
      if (!node) return;
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const height = document.documentElement.scrollHeight - window.innerHeight;
      const pct = height > 0 ? Math.min(1, scrollTop / height) : 0;
      node.style.setProperty('--scroll', pct.toFixed(4));
    };
    const onScroll = () => {
      if (frame.current) cancelAnimationFrame(frame.current);
      frame.current = requestAnimationFrame(update);
    };
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (frame.current) cancelAnimationFrame(frame.current);
    };
  }, []);

  return <div ref={ref} className="scroll-progress" aria-hidden="true" />;
}
